<script type="text/javascript">
	import Textfield from "@smui/textfield";
	import moment from "moment";
	import { get,writable } from "svelte/store";
	import Analytics from "../Analytics/Analytics";
	import AppStore from "../AppStore";
	import AuthStore from "../Auth/Store";
	import LoadState from "../Enums/LoadState";
	import MapStore from "../Map/Store";
	import ModalWindow from "../UI/ModalWindow.svelte";
		
	let responses = AppStore.portAssessments.responses;
	let loadState = AppStore.portAssessments.meta.loadState;
	let lastUpdated = AppStore.portAssessments.meta.lastUpdated;
	let loaded = false;
	let visible = AppStore.portAssessments.visible;
	$: {
		loaded = $loadState === LoadState.LOADED;
	}
	$: {
		$lastUpdated;
		responses = AppStore.portAssessments.responses;
		if (responses && responses[0]) {
			// console.log("responses", responses[0].features[0]);
			responses[0].features.sort((a, b)=>{
				return (a.attributes.Name < b.attributes.Name)
					? -1
					: (a.attributes.Name > b.attributes.Name)
						? 1
						: 0;
			})
		}
	}

	let rawFilterString = writable("");

</script>

<style type="text/css">

.port-assessments-table-container {
	min-height:300px;
	padding-top: 0;
	padding-right: 0;
	height: 300px;
	margin-top:10px;
	overflow-y: scroll;
	overflow-x: hidden;
	resize: vertical;
	border-radius:3px;
	margin-bottom:10px;
}
.port-assessments-table-container .btn-sml {
	display: inline-block;
	font-size: 12px;
	float: right;
	margin-left: 4px;
	cursor:pointer;
}
</style>

{#if loaded}
	<ModalWindow
		title={`Port Assessments`}
		hasCloseButton={true}
		hasBackground={false}
		resizable={true}
		draggable={true}
		fullscreen={false}
		padding={true}
		position="top-right"
		height="70%"
		bind:open={$visible}>

		<Textfield
			dense
			variant="filled"
			label={"Filter by Port Name..."}
			bind:value={$rawFilterString}
			style="width:100%;"
			/>

		<div class="port-assessments-table-container mdc-elevation--z2" >
			<table class='svelte-table'>
				<thead>
					<tr>
						<th>Port Name</th>
						<th width="50">Risk</th>
						<th width="110">Date</th>
						<th width="100">Actions</th>
					</tr>
				</thead>
				<tbody>
					{#each responses[0].features as feature (feature.attributes.Name)}
						{#if ($rawFilterString.trim().length === 0 ||
							feature.attributes.Name.toLowerCase().indexOf($rawFilterString.toLowerCase()) >= 0)}
							<tr>
								<td>{feature.attributes.Name}</td>
								<td>{feature.attributes.ThreatLevel}</td>
								<td>{moment.utc(feature.attributes.AssessmentDate).format("MMM Do YYYY")}</td>
								<td>
									<button class='btn btn-sml bg-info' on:click={()=>{
										Analytics.event("open_assessment_" + feature.attributes.Name, { category: "Ports", username: get(AuthStore.userInfo).username, portName: feature.attributes.Name });
										window.open(feature.attributes.PortAssessmentURL);
									}}>Open</button>
									<button class='btn btn-sml bg-info' on:click={()=>{
										MapStore.helpers.zoomToPoint([feature.geometry.x, feature.geometry.y]);
									}}>Find</button>
								</td>
							</tr>
						{/if}
					{/each}
				</tbody>
			</table>
		</div>

	</ModalWindow>
{/if}
